import type { TourStep } from '../types';

export const navigatingDashboardSteps: TourStep[] = [
  {
    target: '[data-tour="sidebar"]',
    title: 'Sidebar Navigation',
    content:
      'This is your main menu — quick access to every section of Ashlar. Let\'s take a quick tour of what\'s where.',
    placement: 'right',
  },
  {
    target: 'a[href="/dashboard"]',
    title: 'Dashboard',
    content:
      'Your home base. Shows active appraisals, upcoming due dates, pending engagement letters, and site inquiries at a glance.',
    placement: 'right',
    spotlightClicks: true,
  },
  {
    target: 'a[href="/appraisals"]',
    title: 'Appraisals',
    content:
      'Create and manage all your appraisal reports. Start new assignments, open the editor, track statuses, and access standalone tools.',
    placement: 'right',
    spotlightClicks: true,
  },
  {
    target: 'a[href="/calendar"]',
    title: 'Calendar',
    content:
      'Due dates, inspections, and custom events in month/week/day/agenda view. Drag events to reschedule. Try clicking to visit it.',
    placement: 'right',
    spotlightClicks: true,
  },
  {
    target: 'a[href="/leads"]',
    title: 'Leads',
    content:
      'Inquiries from your public website land here. Respond, convert to appraisals or engagement letters, and track status.',
    placement: 'right',
    spotlightClicks: true,
  },
  {
    target: 'a[href="/mileage"]',
    title: 'Mileage Tracking',
    content:
      'Automatically reconstructs driving mileage from completed inspections. Generate IRS-deductible reports and export for tax filing.',
    placement: 'right',
    spotlightClicks: true,
  },
  {
    target: 'a[href="/business"]',
    title: 'My Business',
    content:
      'Manage your public profile, appraiser website, company information, and team — all in one place.',
    placement: 'right',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="dashboard-stats"]',
    title: 'At-a-Glance Stats',
    content:
      'Real-time counts of total appraisals, in-progress work, completions this month, and overdue reports that need attention.',
    placement: 'bottom',
    route: '/dashboard',
  },
  {
    target: '[data-tour="dashboard-quick-actions"]',
    title: 'Quick Actions',
    content:
      'Shortcut cards for creating new appraisals, checking credit balance, viewing upcoming due dates, and more. Try clicking one.',
    placement: 'top',
    route: '/dashboard',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="dashboard-recent"]',
    title: 'Active Appraisals',
    content:
      'Your current in-progress appraisals with addresses, statuses, and map locations. Click any card to jump straight into the editor.',
    placement: 'left',
    route: '/dashboard',
    spotlightClicks: true,
  },
];
